module.exports = __webpack_public_path__ + "img/22jul4.c353d38c.jpeg";